/* eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  mapGetters
} from 'vuex';
import toast from '../../services/toast';
import axios from 'axios';
import {
  bus
} from '../../main';
import addRlistUser from '../add-rlist-user/index';
import editRlistUser from '../edit-rlist-user/index';
import countries from '../../services/country.json'
export default {
  name: 'rlistUsers',
  components: {
    'add-rlist-user': addRlistUser,
    'edit-rlist-user': editRlistUser
  },
  props: [],
  data() {
    return {
      i: '',
      userList: {
        next: ''
      },
      nextStep: '',
      userLoading: false,
      userListResults: [],
      userEditform: false,
      userCreateform: false,
      selectedUserId: '',
      countryList: [],
    }
  },
  computed: {
    ...mapGetters([
      'getrListuserDetailsState',

    ]),
    getUserList() {
      return this.userList = this.$store.getters.getrListuserDetailsState.data
    },
    SetIntialStatus() {
      if (this.userList != undefined) {
        this.totalCount = this.userList.count
        this.nextStep = this.userList.next
        this.userListResults = this.userList.results
      }
    },
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.getUserList
    this.SetIntialStatus
    bus.$on('HideAddUserPopup', (data) => {
      this.userCreateform = data;
      this.selectedUserId = ''
    });
    bus.$on('HideEditUserPopup', (data) => {
      this.userEditform = data;
      this.selectedUserId = ''
    });
  },
  methods: {
    getUserListAgain() {
      this.selectedUserId = ''
      this.$store.dispatch('getRlistUserList').then((res) => {
        this.userList = res.data.data
      }).catch((err) => {})
    },
    loadmoreUser(url) {
      this.userLoading = true
      axios.get(url)
        .then((response) => {
          // debugger
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          // console.log(this.loadmoreData, this.nextStep)
          this.$set(this.userList, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            // debugger
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.userListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
            // toast.success(this.loadmoreData.msg);
            // this.userList.push(this.loadmoreData)
          }
        });
    },
    addRlistUser: function() {
      this.userCreateform = true;
    },
    editRListUser: function(userId) {
      this.selectedUserId = userId;
      this.userEditform = true;
    },
    deleteUser: function() {
      let data = {
        id: this.selectedUserId
      }
      this.$store.dispatch('removeRListUser', data)
        .then((res) => {
          if (res.status == '200' || res.status == '202') {
            this.getUserListAgain()
            toast.success(res.data.msg);
          }
        })
        .catch((err) => {})
    },
    removeUserConfirmation: function(userId) {
      this.selectedUserId = userId;
      $('#removeUser').modal('show');
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/flags/${country.value}.svg`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    }
  },
  beforeMount() {
    this.getUserList;
  },
  watch: {
    getUserList() {
      return this.$store.getters.getrListuserDetailsState
    },
    SetIntialStatus() {
      if (this.userList != undefined) {
        this.totalCount = this.userList.count
        this.nextStep = this.userList.next
        this.userListResults = this.userList.results
      }
    },
  }
}